import React, { useEffect, useState } from "react";

import { loadContactOptionsPaginated, proxyAPI } from "../proxyAPI";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import MyPagination from "../Common/MyPagination";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { contactOption } from "./RealtimeReportingPage";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";
import ReportingContactsList from "./ReportingContactsList";

export default function TicketReporting() {
  const [tickets, setTickets] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [topics, setTopics] = useState([]);
  const [filterTopics, setFilterTopics] = useState([]);
  const [filterContacts, setFilterContacts] = useState([]);
  const [dateLTE, setDateLTE] = useState(null);
  const [dateGTE, setDateGTE] = useState(null);
  const [closedLTE, setClosedLTE] = useState(null);
  const [closedGTE, setClosedGTE] = useState(null);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const getTickets = async (page = 0, perPage = 10) => {
    setLoading(true);
    const data = await proxyAPI({
      prefix: "logic/reporting",
      url: `tickets?pagination.perPage=${perPage}&pagination.page=${page}${
        filterTopics.length > 0
          ? `&filters.topics=${filterTopics.join("&filters.topics=")}`
          : ""
      }${
        filterContacts.length > 0
          ? `&filters.contact_uuids=${filterContacts.join(
              "&filters.contact_uuids="
            )}`
          : ""
      }${search.length > 0 ? `&filters.search=${search}` : ""}${
        dateGTE ? `&filters.date_gte=${dateGTE}` : ""
      }${dateLTE ? `&filters.date_lte=${dateLTE}` : ""}${
        closedGTE ? `&filters.closed_gte=${closedGTE}` : ""
      }${closedLTE ? `&filters.closed_lte=${closedLTE}` : ""}`,
    });

    setTimeout(() => {
      setLoading(false);
      if (data?.data) {
        setTickets(data.data);
        setTotal(data.info.total);
      }
    }, 500);
  };

  useEffect(() => {
    (async () => {
      const topicsData = await proxyAPI({
        prefix: "logic/reporting",
        url: `topics`,
      });
      if (topicsData) {
        setTopics(topicsData.data);
      }
    })();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearch(searchInput);
    }, 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [searchInput]);

  return (
    <div>
      <FullScreenLoadingIndicator loading={loading} />
      <div className=" ">
        <fieldset disabled={loading}>
          <div className="row mb-3 bg-colored-reverse rounded-3 p-3 mx-0">
            <div className="col-md-2">
              <label htmlFor="" className="text-white fw-bold">
                Topics{" "}
              </label>
              <Input
                inputType="select"
                isMulti
                placeholder="Select topics"
                isValidNewOption={() => false}
                value={filterTopics}
                onChange={(v) => setFilterTopics(v)}
                options={topics.map((t) => ({ value: t.uuid, label: t.label }))}
              />
            </div>
            <div className="col-md-2 ">
              <label htmlFor="" className="text-white fw-bold">
                Contacts
              </label>
              <Input
                isMulti
                placeholder="Select contacts"
                value={filterContacts}
                onChange={(v) => setFilterContacts(v)}
                isValidNewOption={() => false}
                loadOptions={loadContactOptionsPaginated}
                components={{ Option: contactOption }}
              />
            </div>
            <div className="col-md-2">
              <label htmlFor="" className="text-white fw-bold">
                Date after
              </label>
              <Input
                inputType="dateTime"
                dateTimeType="dateTime"
                isClearable
                value={[dateGTE]}
                onChange={(v) => setDateGTE(v[0])}
              />
            </div>
            <div className="col-md-2">
              <label htmlFor="" className="text-white fw-bold">
                Date before
              </label>
              <Input
                inputType="dateTime"
                dateTimeType="dateTime"
                isClearable
                value={[dateLTE]}
                onChange={(v) => setDateLTE(v[0])}
              />
            </div>
            <div className="col-md-2">
              <label htmlFor="" className="text-white fw-bold">
                Closed after
              </label>
              <Input
                inputType="dateTime"
                dateTimeType="dateTime"
                isClearable
                value={[closedGTE]}
                onChange={(v) => setClosedGTE(v[0])}
              />
            </div>
            <div className="col-md-2">
              <label htmlFor="" className="text-white fw-bold">
                Closed before
              </label>
              <Input
                inputType="dateTime"
                dateTimeType="dateTime"
                isClearable
                value={[closedLTE]}
                onChange={(v) => setClosedLTE(v[0])}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="" className="text-white fw-bold">
                Search
              </label>
              <Input
                placeholder="Search tickets"
                value={[searchInput]}
                onChange={(v) => setSearchInput(v[0])}
              />
            </div>
          </div>
        </fieldset>
        <div className="mb-5 bg-white rounded-3 p-3">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="p-3">Ticket</th>
                  <th className="p-3">Description</th>
                  <th className="p-3">Topic</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">Created at</th>
                  <th className="p-3 text-center">Contacts</th>
                  <th className="p-3">Closed at</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((e) => (
                  <tr key={e.uuid}>
                    <td className="p-3">{e.uuid}</td>
                    <td className="p-3">{e.description}</td>
                    <td className="p-3">{e.topic.label}</td>
                    <td className="p-3">{e.status}</td>
                    <td className="p-3">
                      {new Date(
                        e.createdAt.slice(-1) === "Z"
                          ? e.createdAt
                          : `${e.createdAt}Z`
                      ).toLocaleString()}
                    </td>
                    <td className="p-3 text-center">
                      {e.meta.contactsCount ? (
                        <ReportingContactsList
                          label={e.meta.contactsCount}
                          uuid={e.uuid}
                          kind="ticket"
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="p-3">{e.closedAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <MyPagination
        total={total}
        onPaginate={getTickets}
        key={[
          filterTopics,
          filterContacts,
          search,
          dateGTE,
          dateLTE,
          closedGTE,
          closedLTE,
        ]}
      />
      <JsonCollapse json={tickets} />
    </div>
  );
}
